import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press14',
  templateUrl: './notice-press14.component.html',
  styleUrls: ['./notice-press14.component.scss']
})
export class NoticePress14Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
